<ng-container *ngIf="!useRefreshedUi; else refreshedUi">
<div [id]="'select-box-'+title" class="select-box-container">
  <div [id]="'select-box-title-'+title" class="select-box-title">{{ transformTitle(title) }}</div>
  <div class="select-box-search-box">
    <img
      src="assets/gray-search-icon.png"
      class="search-icon"
      alt="search-icon"
    />

    <input
      [id]="'select-box-search-'+title"
      type="text"
      [placeholder]="'Search ' + transformTitle(title)"
      class="select-box-search-box-input"
      matInput
      (focus)="show = true"
      (keyup)="onInput()"
      (keydown)="$event.stopPropagation()"
      (input)="onInput()"
      [(ngModel)]="input"
    />

    <img
      *ngIf="show"
      class="select-box-search-box-icon"
      alt="select-box-search-box-icon-up"
      src="assets/arrow-up.svg"
      (click)="toggleSelectOptions()"
    />
    <img
      *ngIf="!show"
      class="select-box-search-box-icon"
      alt="select-box-search-box-icon-down"
      src="assets/arrow-down.svg"
      (click)="toggleSelectOptions()"
    />
  </div>

  <div [id]="'select-box-select-options-'+title" class="select-box-select-options" [hidden]="!show" id="selectOptions">
    <cdk-virtual-scroll-viewport
      *ngIf="searchList.length > 0"
      class="select-box-virtual-scroll-container"
      [itemSize]="40"
      minBufferPx="400"
      maxBufferPx="600"
      scrollStrategy="block"
    >
      <div
        class="select-box-option"
        *cdkVirtualFor="let option of searchList; templateCacheSize: 0"
        (click)="selectOption(option)"
      >
      <input 
      *ngIf="type=='checkbox'"
      type="checkbox" [ngModel]="option.checked" />
      <input 
      *ngIf="type=='radio'"
      type="radio"  [value]="option.val" [checked]="option.checked"  [name]="title"/>
      {{ option.val }}
      </div>
    </cdk-virtual-scroll-viewport>
    <div *ngIf="searchList.length === 0" class="select-box-no-data">
      No Data
    </div>    
  </div>
</div>
</ng-container>

<ng-template #refreshedUi>
<div [id]="'select-box-'+title" class="select-box-container">
  <div [id]="'select-box-title-'+title" class="text-sm pb-[5px] font-normal leading-[135%] text-neptune-default">{{ transformTitle(title) }}</div>
  <div class="rounded-[2px] bg-white border border-neptune-neutral px-3 py-2 or px-[12px] py-2 flex items-center">
    <img
      src="assets/shared-icons/neptune-icon-black-advanced-filter-search.svg"
      class="w-[18px] h-[18px] m-0"
      alt="advanced-filter-search-icon"
    />

    <input
      [id]="'select-box-search-'+title"
      type="text"
      [placeholder]="'Search ' + transformTitle(title)"
      class="!text-sm border-0 outline-none w-full h-full !text-neptune-default"
      (focus)="show = true"
      (keyup)="onInput()"
      (keydown)="$event.stopPropagation()"
      (input)="onInput()"
      [(ngModel)]="input"
    />

    <img
      *ngIf="show"
      class="p-[5px] cursor-pointer transform scale-y-[-1]"
      alt="select-box-search-box-icon-up"
      src="assets/shared-icons/neptune-icon-black-chevron-down.svg"
      (click)="toggleSelectOptions()"
    />
    <img
      *ngIf="!show"
      class="p-[5px] cursor-pointer"
      alt="select-box-search-box-icon-down"
      src="assets/shared-icons/neptune-icon-black-chevron-down.svg"
      (click)="toggleSelectOptions()"
    />
  </div>

  <div [id]="'select-box-select-options-'+title" class="border border-neptune-default bg-white" [hidden]="!show" id="selectOptions">
    <div class="flex items-center justify-between px-3 py-2 text-sm">
      <div class="flex items-center justify-between gap-2">
        <input *ngIf="type=='checkbox'"
        type="checkbox"
        [(ngModel)]="isSelectAllChecked"
        (change)="updateSelectionFromCheckbox($event)"
        >
        <div>Select All </div>
      </div>
      <div 
        [id]="'select-box-clear-all-'+title"
        class="cursor-pointer text-blue mr-2" (click)="clearAllOptions()"
      >Clear All</div>
    </div>
    
    <cdk-virtual-scroll-viewport
      *ngIf="searchList.length > 0"
      class="h-[150px] overflow-y-auto"
      [itemSize]="40"
      minBufferPx="400"
      maxBufferPx="600"
      scrollStrategy="block"
    >
      <div
        class="px-6 py-2 text-sm cursor-pointer h-6"
        *cdkVirtualFor="let option of searchList; templateCacheSize: 0"
        (click)="selectOption(option)"
      >
      <input 
      *ngIf="type=='checkbox'"
      type="checkbox" [ngModel]="option.checked" />
      <input 
      *ngIf="type=='radio'"
      type="radio"  [value]="option.val" [checked]="option.checked"  [name]="title"/>
      {{ option.val }}
      </div>
    </cdk-virtual-scroll-viewport>
    <div *ngIf="searchList.length === 0" class="select-box-no-data">
      No Data
    </div>    
  </div>
</div>
</ng-template>